import { render, staticRenderFns } from "./crypto-sign-info-page.vue?vue&type=template&id=34c95b43&"
import script from "./crypto-sign-info-page.vue?vue&type=script&lang=ts&"
export * from "./crypto-sign-info-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports